import AWN from 'awesome-notifications';

// Global Awesome Notification
export const toast = new AWN({
  position: ['top-right'],
  showProgressBar: true,
});